import { FC } from "react";
import { useDisclosure } from "@repo/hooks";
import { Disclosure } from "@repo/ui";
import { LOGIN_PAGE_NAME } from "@/constants";

const Disclosures: FC = () => {
  const { data: disclosures } = useDisclosure(LOGIN_PAGE_NAME);

  return <Disclosure disclosures={disclosures} />;
};

export default Disclosures;
